module.exports = __webpack_public_path__ + "img/Img17_211113_CaFg-1-Vase29.0cd741f4.jpg";